import Color from 'color'
import { ISettingsFormValues } from '../../../containers/Form/Settings/SettingsForm'
import { EventStatus } from '../../Event'
import { FeedingType, ICustomReservation, ISettings } from '..'

export default function(item: ISettings): ISettingsFormValues {
  const {
    colors,
    names,
  }: {
    colors: ICustomReservation<Color>
    names: ICustomReservation
  } = item.customReservationStatus

  return {
    advanceCustomColor: colors[EventStatus.Advance].rgb().toString(),
    advanceCustomLabel: names[EventStatus.Advance],
    cancelFree: item.cancelFree,
    cancelPay: item.cancelPay,

    canceledCustomColor: colors[EventStatus.Canceled].rgb().toString(),
    canceledCustomLabel: names[EventStatus.Canceled],
    dateFormat: item.dateFormat ? item.dateFormat.date : '',

    daynightFrom: item.daynightFrom,
    daynightTo: item.daynightTo,
    eventLabel: item.eventLabel,

    eventShape: item.eventShape || 'diamond',
    feedingType: item.defaultFeedingType
      ? item.defaultFeedingType
      : FeedingType.WithoutFood,
    fullPaymentCustomColor: colors[EventStatus.Full].rgb().toString(),
    show_busy_terms: item.show_busy_terms,
    fullPaymentCustomLabel: names[EventStatus.Full],
    hourFormat: item.dateFormat ? item.dateFormat.hour : '',
    noAvailableCustomColor: colors[EventStatus.Unavailable].rgb().toString(),

    noAvailableCustomLabel: names[EventStatus.Unavailable],
    noPaymentCustomColor: colors[EventStatus.NoPayment].rgb().toString(),
    noPaymentCustomLabel: names[EventStatus.NoPayment],
    prepaidType: item.defaultPrepaidType || 0,
    reservationStatus: item.defaultReservationStatus,

    serviceBedding: item.serviceBedding,
    serviceBeddingCheck: !!(item.serviceBeddingStatus || item.serviceBedding),

    serviceBeddingDays: item.serviceBeddingDays,
    serviceBeddingStatus: item.serviceBeddingStatus,

    serviceCleaning: item.serviceCleaning,
    serviceCleaningCheck: !!(
      item.serviceCleaningStatus || item.serviceCleaning
    ),

    serviceCleaningDays: item.serviceCleaningDays,
    serviceCleaningStatus: item.serviceCleaningStatus,

    serviceTowels: item.serviceTowels,
    serviceTowelsCheck: !!(item.serviceTowelsStatus || item.serviceTowels),

    serviceTowelsDays: item.serviceTowelsDays,
    serviceTowelsStatus: item.serviceTowelsStatus,

    summaryCheckInOut: item.summary && item.summary.checkinout,
    summaryFeeding: item.summary && item.summary.feeding,
    summaryFulfillment: item.summary && item.summary.fulfillment,
    send_mail_client_reservation: item.send_mail_client_reservation,
    send_mail_reservation: item.send_mail_reservation,
  }
}
